import { useAppSelector } from '../../store/store';
import { Navigate, Outlet } from 'react-router';

const ProtectedRoute = () => {
  const user = useAppSelector((state) => state.user.user);

  if (user && user.SessionId) {
    return <Outlet />;
  }

  // If the user is not logged in, redirect them to the login page.
  return <Navigate to="/user/login" replace />;
};

export default ProtectedRoute;